import { type ReactNode } from "react"

interface Feature {
  /** Icon element (rendered in text-blue-200) */
  icon: ReactNode
  /** Feature text */
  text: string
}

interface KeyFeaturesCardProps {
  /** Card heading (defaults to "Key Features") */
  title?: string
  /** List of features with icons */
  features: Feature[]
  /** Additional classes on the wrapper */
  className?: string
}

export function KeyFeaturesCard({
  title = "Key Features",
  features,
  className = "",
}: KeyFeaturesCardProps) {
  return (
    <div className={`p-6 bg-[#0469f0] text-white rounded-lg flex flex-col justify-center ${className}`}>
      <h3 className="text-base font-bold mb-3">{title}</h3>
      <ul className="space-y-2.5">
        {features.map((feature, i) => (
          <li key={i} className="flex items-center gap-3">
            <span className="w-5 h-5 text-blue-200 flex-shrink-0">{feature.icon}</span>
            <span className="font-medium text-sm">{feature.text}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
